import React = require('react');
import { FaSpinner } from 'react-icons/fa';

interface ILoadingSpinnerProps {
  text: string
}

export const LoadingSpinner = ({text}: ILoadingSpinnerProps) => {
  return (
    <div style={{textAlign: 'center', marginTop: '100px'}}>
      <div>{text}</div>
      <FaSpinner className="fa-spin" style={{fontSize: '40px', marginTop: '30px'}}/>
    </div>
  )
}
